module.exports = __webpack_public_path__ + "img/stephanie.2cbb75bc.png";